/**
 * The attorney's latest library searches, newest first. Kept in this browser
 * only (localStorage): a search is a convenience to repeat, not a record.
 */
export const RECENT_SEARCHES_KEY = "caseblink.research.recent";
export const RECENT_LIMIT = 8;

const storage = (): Storage | null => {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
};

/** Keeps the newest first, drops repeats (ignoring case), and caps the list. */
export const withSearch = (
  recent: readonly string[],
  query: string
): string[] => {
  const text = query.trim();
  if (!text) return [...recent];
  const key = text.toLowerCase();
  return [text, ...recent.filter((q) => q.toLowerCase() !== key)].slice(
    0,
    RECENT_LIMIT
  );
};

export const readRecentSearches = (): string[] => {
  const raw = storage()?.getItem(RECENT_SEARCHES_KEY);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed
          .filter((q): q is string => typeof q === "string")
          .slice(0, RECENT_LIMIT)
      : [];
  } catch {
    return [];
  }
};

export const rememberSearch = (query: string): string[] => {
  const next = withSearch(readRecentSearches(), query);
  storage()?.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  return next;
};

export const clearRecentSearches = (): void => {
  storage()?.removeItem(RECENT_SEARCHES_KEY);
};
